var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconHome = function SvgIconHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9404",
    "data-name": "Grupo 9404",
    transform: "translate(-676 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6319",
    "data-name": "Caminho 6319",
    d: "M1783.371,969.348a17,17,0,1,0,17,17,17,17,0,0,0-17-17",
    transform: "translate(-1089.371 -937.348)",
    fill: "none",
    stroke: "#4b4b4b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6320",
    "data-name": "Caminho 6320",
    d: "M281.414-2315.565h.555a2.678,2.678,0,0,1,1.376.871q3.772,3.79,7.561,7.562a2.818,2.818,0,0,1,.926,1.432v.554a.5.5,0,0,0-.037.088,1.847,1.847,0,0,1-1.813,1.5c-.1,0-.206,0-.324,0v.265c0,1.921,0,3.842,0,5.762a2.17,2.17,0,0,1-2.262,2.249h-3.049c-.485,0-.708-.226-.708-.717q0-2.317,0-4.634a.951.951,0,0,0-.918-1c-.692-.025-1.386-.024-2.078,0a.947.947,0,0,0-.892.959c0,.191,0,.383,0,.574q0,2.079,0,4.158a.6.6,0,0,1-.654.652c-1.089,0-2.178.007-3.267,0a2.151,2.151,0,0,1-2.09-2.053c-.019-1.987-.009-3.974-.011-5.96,0-.082,0-.165,0-.26-.146,0-.258,0-.37,0a1.807,1.807,0,0,1-1.593-1,1.856,1.856,0,0,1,.4-2.245q3.933-3.936,7.865-7.873A2.713,2.713,0,0,1,281.414-2315.565Z",
    transform: "translate(412.313 2354.424)",
    fill: "#4b4b4b"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_home.1dff3fc5.svg";
export { ForwardRef as ReactComponent };